/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import styled from 'styled-components';
import {
  TYPE_OPTION_CORONAL_ANTERIOR,
  TYPE_OPTION_CORONAL_POSTERIOR,
  TYPE_OPTION_AXIAL_SUPERIOR,
  TYPE_OPTION_AXIAL_INFERIOR,
  TYPE_OPTION_SAGITAL_DERECHA,
  TYPE_OPTION_SAGITAL_IZQUIERDA,
} from './renderer/Image3d/volumeInitOptions';

export const CameraLetters = [
  { id: TYPE_OPTION_CORONAL_ANTERIOR, letter: 'A' },
  { id: TYPE_OPTION_CORONAL_POSTERIOR, letter: 'P' },
  { id: TYPE_OPTION_AXIAL_SUPERIOR, letter: 'H' },
  { id: TYPE_OPTION_AXIAL_INFERIOR, letter: 'F' },
  { id: TYPE_OPTION_SAGITAL_DERECHA, letter: 'R' },
  { id: TYPE_OPTION_SAGITAL_IZQUIERDA, letter: 'L' },
];

export const Button = styled.div`
display: flex;
flex-direction: column-reverse;
z-index: 2;
transition: opacity 120ms ease;

&.collapsed {
  opacity: 0.125;
}

&.collapsed:hover {
  opacity: 1;
}
`;

export const SubButton = styled.div`
width: 38px;
height: 38px;
font-size: 1.2em;
padding-top: 10px;

display: flex;
align-items: center;
justify-content: center;

background: grey;
border-bottom: 1px solid black;

&:hover {
      background: #FFFFFF55;
    };
`;

const Wrapper = styled.div`
position: absolute;
bottom: 10px;
right: 12px;
width: 40px;
height: ${(props) => (props.height)};

&:hover {
  background: #FFFFFF55;
};
`;

export const CamButton = ({ cameras, changeCam, initOptions }) => {
  const [isOpen, setIsOpen] = useState(false);

  const cams = cameras.filter((cam) => cam !== initOptions.viewType.camera);
  cams.unshift(initOptions.viewType.camera);

  const getInitialLetter = (cam) => {
    const came = CameraLetters.find((item) => item.id === cam);
    return came.letter;
  };

  const handleChange = (selectedCam) => {
    const index = cameras.findIndex((cam) => cam === selectedCam);

    changeCam(index);
  };

  return (
    <Wrapper
      onClick={() => { (!isOpen ? setIsOpen(true) : setIsOpen(false)); }}
      height={!isOpen ? '40px' : 'auto'}
    >
      <Button
        onClick={() => setIsOpen(true)}
        className={!isOpen ? 'collapsed' : undefined}
      >
        {(isOpen ? cams : cams.slice(0, 1)).map((cam) => (
          <SubButton key={cam} onClick={() => handleChange(cam)}>
            <p>{getInitialLetter(cam)}</p>
          </SubButton>
        ))}
      </Button>
    </Wrapper>
  );
};
